(function ($) {
    $(document).ready(function () {

        // Header CTA Action Style
        if($('.menu--ctas').length) {

            if($('.menu--ctas').hasClass('full-height')) {

                $('#masthead').addClass('header-cta-full-height');
            }
        }

        // Homepage
        if($('.home').length) {

            if($('.highlight').length) {

                $('.highlight').find('a').addClass('cta-secondary');
            }

            if($('.hp-image-row').length) {

                $('.hp-image-row').each(function(){
                    var _this = $(this);
                    _this.css({'background-image': 'url(' + _this.find('img').attr('src') + ')'});
                });
            }

            if($('.hp-award-row').length ) {

                $('.hp-award-row').each(function () {
                    var _this = $(this);
                    var _div = $('<div class="normal-container"></div>');
                    var _target = _this.find('.wp-block-column');
                    _target.wrapAll(_div);
                });
            }

            // AOS Init
            $('.hp-hr-row, .highlight, .entry-content .pici-venue-details, .reuse-4-col, .feature-box, .hp-gallery-row .wp-block-column:not(.gallery), .hp-award-row, .sbi, .banner-cta')
                .attr('data-aos', 'fade-up')
                .attr('data-aos-duration', '1000');
            $('.hp-image-row, .hp-gallery-row .wp-block-gallery .slick-current')
                .attr('data-aos', 'zoom-out-up')
                .attr('data-aos-duration', '500');

            AOS.init();
        }

        // Our Philosophy
        if($('.our-philosophy').length) {
            var _div = $('<div class="normal-container"></div>');
            var _target = $('.our-philosophy').find('.wp-block-column');
            _target.wrapAll(_div);
        }

        // Enquiry Form
        if ($('.enquiry-form').length) {
            var _this = $('.enquiry-form');
            var _div = $('<div class="normal-container"></div>');
            var _target = _this.find('.wp-block-column');
            _target.wrapAll(_div);
        }

        // Gallery Row
        if($('.hp-gallery-row, .pv-gallery-row, .pv-event-gallery-row').length) {

            $('.hp-gallery-row, .pv-gallery-row, .pv-event-gallery-row').each(function(){
                $(this).find('.blocks-gallery-item').each(function(){
                    var _this = $(this);
                    _this.css({'background-image': 'url(' + _this.find('img').attr('src') + ')'});
               });
            });
        }
    });


    $(window).load(function(){

        setTimeout(function(){
            $('.home').addClass('loaded');
        }, 100);

    });
})(jQuery);